/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import { mapGetters, mapState } from 'vuex'
import Avatar from '../../../../frontend/views/components/Avatar.vue'
import Badge from '../../../../frontend/views/components/Badge.vue'
import Tooltip from '../../../../frontend/views/components/Tooltip.vue'
import { OPEN_MODAL } from '../../../../frontend/utils/events.js'
import { fetchNews } from '../../../../frontend/views/utils/misc.js'

const __vue_script__ = ({
  name: 'GroupsList',
  components: {
    Avatar,
    Badge,
    Tooltip
  },
  data () {
    return {
      ephemeral: {
        latestNewsDate: null
      }
    }
  },
  created () {
    this.checkForNewNews()
  },
  computed: {
    ...mapState([
      'currentGroupId'
    ]),
    ...mapGetters([
      'groupsByName',
      'groupUnreadMessages',
      'unreadGroupNotificationCountFor',
      'ourPreferences'
    ]),
    badgeVisiblePerGroup () {
      return Object.fromEntries(
        this.groupsByName.map(group => ([
          group.contractID,
          this.groupUnreadMessages(group.contractID) + this.unreadGroupNotificationCountFor(group.contractID) > 0
        ]))
      )
    },
    isInGlobalDashboard () {
      return this.$route.path.startsWith('/global-dashboard')
    },
    hasNewNews () {
      // Don't show badge if we're currently on the news page
      if (this.$route.path === '/global-dashboard/news-and-updates' ||
        !this.ourPreferences?.lastSeenNewsDate ||
        !this.ephemeral.latestNewsDate
      ) {
        return false
      }

      return new Date(this.ephemeral.latestNewsDate) > new Date(this.ourPreferences.lastSeenNewsDate)
    }
  },
  methods: {
    openModal (mode) {
      sbp('okTurtles.events/emit', OPEN_MODAL, mode)
    },
    handleMenuSelect (id) {
      id && this.changeGroup(id)

      if (this.isInGlobalDashboard) {
        this.$router.push('/dashboard')
      }
    },
    onGlobalDashboardClick () {
      this.$router.push(({ path: '/global-dashboard' }))
    },
    changeGroup (hash) {
      const path = this.$route.path
      const emptyGroupPicture = this.groupPictureForContract(hash) === ''
      if (hash !== this.currentGroupId) {
        sbp('gi.app/group/switch', hash)
      }
      if (emptyGroupPicture && path !== '/pending-approval') {
        this.$router.push(({ path: '/pending-approval' }))
      } else if (!emptyGroupPicture && path === '/pending-approval') {
        this.$router.push(({ path: '/dashboard' }))
      }
    },
    groupPictureForContract (contractID) {
      return this.$store.state[contractID]?.settings?.groupPicture || ''
    },
    async checkForNewNews () {
      try {
        const data = await fetchNews()
        if (data.length > 0) {
          this.ephemeral.latestNewsDate = data[0].createdAt
        }
      } catch (error) {
        console.error('Failed to check for new news:', error)
      }
    }
  }
}        )

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.groupsByName.length)?_c('ul',{staticClass:"c-group-list",attrs:{"data-test":"groupsList"}},[_c('li',{staticClass:"c-group-list-item group-badge",class:{ "is-active": _vm.isInGlobalDashboard }},[_c('tooltip',{attrs:{"direction":"right","text":_vm.L("Global dashboard")}},[_c('button',{staticClass:"c-group-picture is-unstyled c-global-dashboard-logo",on:{"click":_vm.onGlobalDashboardClick}},[_c('avatar',{staticClass:"c-avatar",attrs:{"src":"/assets/images/group-income-icon-transparent-circle.png","alt":"Global dashboard logo"}})],1),(_vm.hasNewNews)?_c('badge',{attrs:{"type":"compact","data-test":"globalDashboardBadge"}}):_vm._e()],1)],1),_vm._l((_vm.groupsByName),function(group,index){return _c('li',{key:("group-" + index),staticClass:"c-group-list-item group-badge",class:{ "is-active": !_vm.isInGlobalDashboard && _vm.currentGroupId === group.contractID}},[_c('tooltip',{attrs:{"direction":"right","text":group.groupName}},[_c('button',{staticClass:"c-group-picture is-unstyled",on:{"click":function($event){return _vm.handleMenuSelect(group.contractID)}}},[_c('avatar',{staticClass:"c-avatar",attrs:{"src":_vm.groupPictureForContract(group.contractID)}})],1),(_vm.badgeVisiblePerGroup[group.contractID])?_c('badge',{attrs:{"type":"compact","data-test":("groupBadge-" + (group.groupName))}}):_vm._e()],1)],1)}),_c('li',{staticClass:"c-group-list-item"},[_c('tooltip',{attrs:{"direction":"right","text":_vm.L("Create a new group")}},[_c('button',{staticClass:"is-icon has-background",attrs:{"data-test":"createGroup","aria-label":_vm.L("Add a group")},on:{"click":function($event){return _vm.openModal("GroupCreationModal")}}},[_c('i',{staticClass:"icon-plus"})])])],1)],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-04db434e_0", { source: ".c-badge[data-v-04db434e]{top:0;right:1px;z-index:2}.c-group-list[data-v-04db434e]{width:3.5rem;padding-top:.7rem;background-color:var(--general_1)}.c-group-list-item[data-v-04db434e]{position:relative;display:flex;justify-content:center;align-items:center;height:3.2rem;margin-bottom:.25rem}.group-badge[data-v-04db434e]::before{content:\"\";position:absolute;width:3rem;height:3rem;border:1px solid transparent;border-radius:50%;transform:scale(.7);transition:all .25s cubic-bezier(.18,.89,.32,1.38)}.group-badge.is-active[data-v-04db434e]::before{transform:scale(1);border-color:var(--text_0);animation:spin-data-v-04db434e .5s ease-out}.group-badge[data-v-04db434e]:not(.is-active){cursor:pointer}.group-badge[data-v-04db434e]:not(.is-active):focus::before,.group-badge[data-v-04db434e]:not(.is-active):hover::before{border-color:#fff;border-width:3px;transform:scale(1.1)}@keyframes spin-data-v-04db434e{0%{transform:rotate(45deg);filter:hue-rotate(0);border-color:var(--primary_0) transparent transparent}50%{transform:rotate(315deg);filter:hue-rotate(360deg);border-color:var(--primary_0) transparent transparent}100%{transform:rotate(585deg);border-color:#fff}}.c-avatar[data-v-04db434e]{position:relative;z-index:1}.c-group-picture[data-v-04db434e]{display:flex}.c-group-picture.c-global-dashboard-logo[data-v-04db434e]{background-color:var(--background_0);border-radius:50%;width:2.5rem;height:2.5rem}.c-group-picture.c-global-dashboard-logo[data-v-04db434e]  img.c-avatar{width:1.75rem;height:1.75rem}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-04db434e"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__